import {isResponseError} from '~shared/utils';

import {makeThunkErrorHandler} from '~ui/store/utils';
import {i18n} from '~ui/components/SubscribeDialog/i18n';

export enum SubscriberAddErrors {
    ForbiddenSubscription = 'FORBIDDEN_SUBSCRIPTION',
    General = 'GENERAL',
}

export function getSubscriberAddErrorMessage(code: string): string {
    switch (code) {
        case SubscriberAddErrors.ForbiddenSubscription:
            return i18n('error-add-subscribers-forbidden');
        case SubscriberAddErrors.General:
        default:
            return i18n('error-add-subscribers');
    }
}

export function makeSubscriberAddErrorHandler(error: unknown) {
    const code = isResponseError(error) ? error.code : SubscriberAddErrors.General;
    const message = getSubscriberAddErrorMessage(code);

    return makeThunkErrorHandler({
        name: 'get-comments',
        title: message,
    })(error);
}
